export default "/images/saires.svg?864dcc5380716d483a42a16cb45221fa";